var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XLoader',{attrs:{"loading":_vm.loading,"type":_vm.loaderType,"color":_vm.loaderColor,"min-width":_vm.minWidth,"max-width":_vm.maxWidth,"min-height":_vm.minHeight,"max-height":_vm.maxHeight},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loaded = ref.loaded;
return [_vm._t("default",null,{"loaded":loaded})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }